export default "__VITE_ASSET__8b28a523__"